<template>
  <SimilarJobs
    class="w-100 py-4"
    :jobs="jobs"
    :is-loading="isLoading"
    :show-see-more="showSeeMore"
    @search="handleSearch"
    @locality-change="handleLocalityChange"
    @scope-change="handleScopeChange"
    @card-click="handleCardClick"
    @load-more="handleLoadMore"
    @search-upgrade="handleSearchUpgrade"
  />
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';
import { useSimilarJobs } from '@/stores/document/similarJobs';
import { useTracking } from '@/stores/tracking/tracking';
import { useRouter } from 'vue-router';
import SimilarJobs from '@ui/components/editor/SimilarJobs/SimilarJobs.vue';
import { useEditor } from '@/stores/editor/editor';

const router = useRouter();
const similarJobsStore = useSimilarJobs();

const { jobs, isLoading, showSeeMore } = storeToRefs(similarJobsStore);
const { jobId } = storeToRefs(useEditor());

onMounted(() => {
  similarJobsStore.initialize(jobId.value);
});

const handleSearch = (searchText) => {
  similarJobsStore.handleSearch(searchText);
};

const handleLocalityChange = (locality) => {
  similarJobsStore.handleLocalityChange(locality);
};

const handleScopeChange = (scope) => {
  similarJobsStore.handleScopeChange(scope);
};

const handleCardClick = async (job) => {
  const {
    // eslint-disable-next-line camelcase
    id, tapwage_id, title, company, location,
  } = job;

  useTracking().clickSimilarJob({
    job: {
      jobId: jobId.value,
    },
    props: {
      id,
      title,
      company,
      location,
    },
  });

  await router.push({
    name: 'editor-view',
    params: { id: jobId.value },
    query: {
      ...router.currentRoute.value.query,
      similarJobs: Number(id) || Number(tapwage_id),
    },
  });
};

const handleLoadMore = () => {
  similarJobsStore.loadMore();
};

const handleSearchUpgrade = (text) => {
  similarJobsStore.handleSearchUpgrade(text);
};
</script>
